import baseAPI from "./api";
import { Success } from "../components/commons/Success";
import { AxiosRequestConfig } from "axios";
import { Phonenumber } from "../components/phonenumber/phonenumber.model";

const get = async () => {
  const config: AxiosRequestConfig = {};
  const res = await baseAPI.get(`phonenumber`, config);
  return res.data as Phonenumber;
};

const create = async (phonenumber: string) => {
  const res = await baseAPI.post(`phonenumber`, { phonenumber });
  return res.data as Success<string>;
};

const remove = async (phonenumber: string) => {
  const res = await baseAPI.delete(`phonenumber/${phonenumber}`);
  return res.data as Success<string>;
};

const verify = async (code: string) => {
  const res = await baseAPI.post(`phonenumber/verify`, { code });
  return res.data as Success<string>;
};

const resendCode = async () => {
  const res = await baseAPI.post(`phonenumber/resend-code`);
  return res.data as Success<string>;
};

export const phoneService = {
  get,
  create,
  remove,
  verify,
  resendCode,
};
